import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Es un libro médico sobre cáncer?',
    a: 'No. No explicamos tratamientos ni diagnósticos médicos. Es una guía de gestión emocional y logística para la familia. Te enseñamos a manejar la parte humana, no la clínica.'
  }, {
    q: '¿Sirve para cualquier tipo de cáncer?',
    a: 'Sí. Los principios de apoyo emocional, organización familiar y comunicación son universales, independientemente del diagnóstico específico.'
  }, {
    q: '¿Es un libro físico o digital?',
    a: 'Es 100% digital (PDF). Lo recibes en tu correo inmediatamente después de la compra. Esto nos permite mantener el precio bajo y que lo tengas en el momento exacto en que lo necesitas.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tienes 30 días de garantía total. Si sientes que no te aportó valor, te devolvemos el dinero. Queremos que te sientas seguro con tu decisión.'
  }, {
    q: 'Mi familiar ya está en etapa avanzada, ¿aún me sirve?',
    a: 'Sí. El Capítulo 7 está dedicado específicamente a los momentos difíciles, cuidados paliativos y cómo estar presente cuando las palabras ya no alcanzan.'
  }];
  return <section className="py-16 px-4 bg-[#FDFAF7]" data-id="element-73">
      <div className="max-w-[700px] mx-auto" data-id="element-74">
        <h2 className="text-3xl font-serif font-bold text-[#1C1C2E] text-center mb-8" data-id="element-75">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3 mb-12" data-id="element-76">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-[#E2E8F0] rounded-lg overflow-hidden" data-id="element-77">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-4 text-left font-semibold text-[#1C1C2E] hover:bg-[#EEF2F7] transition-colors" data-id="element-78">
                {faq.q}
                <ChevronDown className={`w-5 h-5 text-[#1B3A6B] transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-79" />
              </button>
              <AnimatePresence data-id="element-80">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-81">
                    <div className="px-4 pb-4 pt-0 text-[#4A4A6A] leading-relaxed border-t border-[#F3F4F6] mt-2" data-id="element-82">
                      <div className="pt-3 text-sm" data-id="element-83">{faq.a}</div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}